/**
 * NKBA API
 * The RESTful backend behind the NKBA application
 *
 * OpenAPI spec version: V1.0.0
 * Contact: cloud@nkba.org
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { AxiosRequestConfig } from 'axios';
import { axios } from '../axios.config';

import { Activity } from '../models/Activity';
import { ResultsPartialActivityObjectId } from '../models/ResultsPartialActivityObjectId';

/* tslint:disable:no-unused-variable member-ordering max-line-length */

export class ActivityApiResource {

    /**
     * Create an activity
     * 
     * @param body User data to create
     */
    public createActivity(body?: Partial<Activity>, axiosConfig?: AxiosRequestConfig): Promise<Activity> {
        const reqPath = '/v1/activity';
        let reqConfig = {
            ...axiosConfig,
            method: 'POST',
            url: reqPath,
            data: body
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Return previous activity, paginated
     * 
     * @param entityId entity id to search activity
     * @param type activity type to find
     * @param from either an activity id, or a date to start searching from
     * @param limit number of results to return
     */
    public findActivity(query?: { entityId?: string, type?: string, subType?: string, from?: string, limit?: number }, axiosConfig?: AxiosRequestConfig): Promise<ResultsPartialActivityObjectId> {
        const reqPath = '/v1/activity';
        let reqConfig = {
            ...axiosConfig,
            method: 'GET',
            url: reqPath,
            params: query
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Return a particular activity entry by id
     * 
     * @param id Activity id
     */
    public getActivity(id: Partial<string>, axiosConfig?: AxiosRequestConfig): Promise<Activity> {
        const reqPath = '/v1/activity/{id}'
                    .replace('{' + 'id}', String(id));
        let reqConfig = {
            ...axiosConfig,
            method: 'GET',
            url: reqPath
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

}

export const ActivityApi = new ActivityApiResource();



// WEBPACK FOOTER //
// ./src/common/api/resources/ActivityApi.ts